module.exports = __webpack_public_path__ + "static/img/total_order.5196ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/total_order.png
// module id = x64m
// module chunks = 0